import payload_plugin_qLmFnukI99 from "/app01/node_modules/@pinia/nuxt/dist/runtime/payload-plugin.js";
import revive_payload_client_4sVQNw7RlN from "/app01/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app01/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app01/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_MwZUzHrRNP from "/app01/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/app01/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/app01/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app01/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/app01/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/app01/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/app01/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app01/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import switch_locale_path_ssr_5csfIgkrBP from "/app01/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/app01/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import plugin_ghbUAjaD3n from "/app01/node_modules/@nuxtjs/device/dist/runtime/plugin.js";
import plugin_tbFNToZNim from "/app01/node_modules/@zadigetvoltaire/nuxt-gtm/dist/runtime/plugin.mjs";
import plugin_HxESNA4J3M from "/app01/modules/lazy-load/runtime/plugin.ts";
import v_calendar_dxaVzst4iS from "/app01/plugins/v-calendar.ts";
import gtm_cXsUZobmSF from "/app01/plugins/gtm.ts";
import v_gtm_VCYDr8Grkg from "/app01/plugins/v-gtm.ts";
import hotjsar_client_tGZktairBP from "/app01/plugins/hotjsar.client.ts";
import auth_client_4lHQFpoKNF from "/app01/plugins/auth.client.ts";
import geo_client_6qNVR3fnBI from "/app01/plugins/geo.client.ts";
import register_sw_client_DRJkQEfV0b from "/app01/plugins/register-sw.client.ts";
import vue_credit_card_validation_BdzAovH6wA from "/app01/plugins/vue-credit-card-validation.ts";
import vue_observe_visibility_eJ2HjGsWX9 from "/app01/plugins/vue-observe-visibility.ts";
export default [
  payload_plugin_qLmFnukI99,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_MwZUzHrRNP,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  plugin_ghbUAjaD3n,
  plugin_tbFNToZNim,
  plugin_HxESNA4J3M,
  v_calendar_dxaVzst4iS,
  gtm_cXsUZobmSF,
  v_gtm_VCYDr8Grkg,
  hotjsar_client_tGZktairBP,
  auth_client_4lHQFpoKNF,
  geo_client_6qNVR3fnBI,
  register_sw_client_DRJkQEfV0b,
  vue_credit_card_validation_BdzAovH6wA,
  vue_observe_visibility_eJ2HjGsWX9
]